import axios from "axios";
import { DownloadReportResponse } from "src/entities/v3/DownloadReportResponse";
import { useAuth } from "./useAuth";

interface DownloadRequest {
  type: "feedback" | "publication";
  articleId: string;
}

export const useDownload = () => {
  const { authInfo } = useAuth();

  const download = async ({ type, articleId }: DownloadRequest) => {
    const url = `${process.env.REACT_APP_DOMAIN_V3}/api/v3/articles/${articleId}/${type}_report/download`;
    try {
      const response = await axios.get<DownloadReportResponse>(url, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          authorization: `Bearer ${authInfo.accessToken}`,
        },
      });

      // 別タブで開く
      if (response?.data?.url) {
        window.open(response.data.url, "_blank");
      }
    } catch (err) {
      console.error(err);
    }
  };

  return {
    download,
  };
};
